import React from 'react';

import { FEmailMessageFragment, useEmailMessageQuery } from '@dashboard/generated/wp/platform';
import { ListItem, ListItemText, Skeleton } from '@mui/material';

type Props = {
  waypointEventId: string;
  label: string;
  children: string | ((event: FEmailMessageFragment) => React.ReactNode);
};

type FProps = {
  primary?: boolean;
  label: string;
  children: React.ReactNode;
};
function Field({ label, primary, children }: FProps) {
  const ch = primary ? (
    <ListItemText sx={{ m: 0, width: '100%', wordBreak: 'break-word' }} primary={children} />
  ) : (
    <ListItemText sx={{ m: 0, width: '100%', wordBreak: 'break-word' }} secondary={children} />
  );

  return (
    <ListItem>
      <ListItemText
        secondary={label}
        sx={{ m: 0, color: 'text.secondary', flexGrow: 0, flexBasis: { xs: 0, sm: 128 } }}
      />
      {ch}
    </ListItem>
  );
}

export default function PreambleField({ waypointEventId, label, children }: Props) {
  const { data } = useEmailMessageQuery({ variables: { id: waypointEventId } });
  const model = data?.EmailMessage;

  if (typeof children === 'string') {
    return (
      <Field primary label={label}>
        {children}
      </Field>
    );
  }
  if (model === undefined) {
    return (
      <Field label={label}>
        <Skeleton width={220} />
      </Field>
    );
  }

  const res = children(model);
  if (!res) {
    return <Field label={label}>--</Field>;
  }
  if (typeof res === 'string' && res.trim().length === 0) {
    return <Field label={label}>--</Field>;
  }
  return (
    <Field primary label={label}>
      {res}
    </Field>
  );
}
